<template>
  <div class="legal container">
    <h2>法律声明</h2>
    <h4>本法律声明适用于网址为：http://www.feichan.tech/的网站（本网站），斐宸数字科技(上海)有限公司（以下统称“斐宸”）保留在没有通知或提示 的情况下随时修改本网站声明的权利。如果您不同意下列任何条款，请停止使用本网站。</h4>
    <!-- 网站内容 -->
    <div class="legal-notice">
      <h3>网站内容</h3>
      <h4>
        本网站所载的材料和信息，包括但不限于文本、图片、数据、用户界面、可视界面、商标、标识、声音、音乐、观点、建议，属于斐宸或其他权利 人所有，但斐宸并不保证上述材料和内容的准确、完整、充分和可靠性，并且明确声明不对上述材料和内容的错误或遗漏承担责任，也不对上述材料和
        内容作出任何明示或默示的、包括但不限于有关所有权的担保、没有侵犯第三方权利、质量和没有计算机病毒的保证。
      </h4>
    </div>
    <!-- 网站使用 -->
    <div class="legal-notice">
      <h3>网站使用</h3>
      <h4>您不得出于任何非法或本使用条款禁止的目的使用本网站和/或其包含的任何内容，不得将本网站和/或其包含的任何内容用于任何非法用途，也不得唆使任何非法活动或其他侵犯新开普或他人权利的活动。</h4>
      <h4>您不得以任何方式（包括但不限于使用任何设备、软件或程序）干扰或试图干扰本网站的正常运作及其他人对本网站的正常使用。</h4>
      <h4>您不得为出版和/或发行和/或为任何其他商业目的以任何方式（包括“镜像”）将本网站的任何部分及任何内容复制、再制、重印、上传、发布、公开展示、编码、翻译、传输或散布至任何其他计算机、服务器、网站或其他媒介。</h4>
      <h4>您同意在使用本网站及其内容时，遵守国家法律法规、社会公共道德。您不得利用本网站及其内容从事制作、查阅、复制和传播任何违法、侵犯他人权益等扰乱社会秩序、破坏社会稳定的行为，亦不得利用本网站及其内容从事任何危害或试图危害计算机系统及网络安全的活动。</h4>
      <h4>在任何情况下，斐宸都不对您或任何第三方因违反本声明产生的任何损害承担赔偿责任。访问、使用本网站所产生的损坏计算机系统或移动通讯设备数据库的风险将由您个人承担。</h4>
    </div>
    <!-- 隐私政策 -->
    <div class="legal-notice">
      <h3>隐私政策</h3>
      <h4>斐宸的隐私政策适用于本网站的使用。使用本网站，即表示您确认并同意新开普可以根据此隐私声明使用此类信息。</h4>
    </div>
    <!-- 第三方链接 -->
    <div class="legal-notice">
      <h3>第三方链接</h3>
      <h4>本网站可能保留有与第三方网站或网址的链接，访问这些链接将由用户自行决定，斐宸不保证这些链接上所提供的任何信息、数据、观点、图片、陈 述或建议的准确性、完整性、充分性和可靠性。斐宸仅为方便访问者而提供这些链接网站，并不表示斐宸对这些信息的认可和推荐，也不是用于宣传或广 告目的。</h4>
    </div>
    <!-- 管辖法律 -->
    <div class="legal-notice">
      <h3>管辖法律</h3>
      <h4>本声明及您访问或使用本网站相关的所有事项将受中华人民共和国法律管辖。您同意上海市有管辖权的法院具有相关的管辖权。</h4>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Legal',
};
</script>
<style scoped>
.legal {
  margin-bottom: 100px;
}
.legal h2 {
  margin: 100px;
  text-align: center;
  font-size: 48px;
  color: #333;
  font-weight: bold;
}
.legal h4 {
  margin-bottom: 39px;
  font-size: 18px;
  font-weight: 400;
  line-height: 1.7;
  color: #666;
  text-indent: 2em;
}
.legal-notice h3 {
  margin-top: 100px;
  margin-bottom: 39px;
  font-size: 24px;
  font-weight: bold;
  color: #666;
}
</style>
